import React from "react"
import HeroPrimary1 from "../../components/HeroModuls/HeroPrimary1"
import HeroPrimary2 from "../../components/HeroModuls/HeroPrimary2"
import HeroSecondary from "../../components/HeroModuls/HeroSecondary"
import HeroTertiary from "../../components/HeroModuls/HeroTertiary"
import HeroContact from "../../components/HeroModuls/HeroContact"
import { getTextAndHeadingClassesHero } from "../../services/functions"

type HeroRendererProps = {
    heroes: any[]
}

export default function HeroRenderer(props: HeroRendererProps) {
    const heroRegistry: { [key: string]: React.ComponentType<any> } = {
        heroPrimary1: HeroPrimary1,
        heroPrimary2: HeroPrimary2,
        heroSecondary: HeroSecondary,
        heroTertiary: HeroTertiary,
        heroContact: HeroContact,
    }

    

    return (
        <>
            {props?.heroes?.map((hero, index) => {
                const HeroComponent = heroRegistry[hero?.type]
                if (!HeroComponent) {
                    return (
                        <div key={index}>
                            Kein hero für Typ: <strong>{hero?.type}</strong>
                        </div>
                    )
                }
                return (
                    <div key={index} className={`${getTextAndHeadingClassesHero(hero)}`}>
                        <HeroComponent {...hero}/>
                    </div>
                )
            })}
        </>
    )
}
